import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { processGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        toast.error('Invalid authentication callback');
        navigate('/login');
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        await processGoogleSession(sessionId);
        toast.success('Successfully signed in with Google!');
        navigate('/', { replace: true });
      } catch (error) {
        console.error('Google auth error:', error);
        toast.error('Failed to authenticate with Google');
        navigate('/login');
      }
    };

    processSession();
  }, [location.hash, navigate, processGoogleSession]);

  return (
    <div className="min-h-screen bg-[#FFFDF8] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[#FF3B6B]/30 border-t-[#FF3B6B] rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-[#6B6B7A]">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
